/**
 * Haptics (GDD §8): a short pulse on explosions and a longer one on a crash, where the device can vibrate (the
 * Vibration API; iPhone and iPad browsers have none, so nothing happens there). Pulses closer together than a
 * frame or two merge, so a chain of explosions doesn't buzz continuously.
 */

/** Pulse lengths (ms): an explosion scales with its size; a crash is long. */
export function pulseMs(kind: 'boom' | 'crash', size = 1): number {
  return kind === 'crash' ? 260 : Math.round(Math.min(45, 14 + 12 * size));
}

/** Shortest time between explosion pulses (ms). */
const MIN_GAP = 70;

export interface Haptics {
  enabled: boolean;
  readonly supported: boolean;
  pulse(kind: 'boom' | 'crash', size?: number): void;
}

export function createHaptics(nav: Navigator, now: () => number = () => performance.now()): Haptics {
  const supported = typeof nav.vibrate === 'function';
  let last = -Infinity;
  return {
    enabled: true,
    supported,
    pulse(kind, size = 1) {
      if (!this.enabled || !supported) return;
      const t = now();
      if (kind === 'boom' && t - last < MIN_GAP) return;
      last = t;
      try {
        nav.vibrate(pulseMs(kind, size));
      } catch {
        // Vibration can be blocked (no user gesture yet); the game plays on.
      }
    },
  };
}
